import axios from "axios";
import config from "_config/config.js";
import { axiosInstance } from "./interceptor";
import variables from "_constants/variables";

import localOrSessionStore from "_helpers/localOrSessionStore";
const storage = localOrSessionStore({ key: variables.REMEMBER });

export const xcService = {
  get,
  post,
  put,
  patchToken,
  postToken,
  getToken,
  putToken,
  deleteToken,
  getTokenWithBody,
  postTokenFile,
};

async function get(apiEndpoint) {
  return axios
    .get(config.backendUrl + apiEndpoint, getOptions())
    .then((response) => {
      return response;
    })
    .catch((err) => {
      return err.response;
    });
}

async function getToken(apiEndpoint) {
  return axiosInstance
    .get(config.backendUrl + apiEndpoint, getOptionsToken())
    .then((response) => {
      return response;
    })
    .catch((err) => {
      return err.response;
    });
}

async function getTokenWithBody(payload, apiEndpoint) {
  return axiosInstance
    .get(config.backendUrl + apiEndpoint, payload)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      return err.response;
    });
}

async function postToken(apiEndpoint, payload) {
  return axiosInstance
    .post(config.backendUrl + apiEndpoint, payload, getOptionsToken())
    .then((response) => {
      return response;
    })
    .catch((err) => {
      return err.response;
    });
}

async function postTokenFile(apiEndpoint, payload) {
  return axiosInstance
    .post(config.backendUrl + apiEndpoint, payload)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      return err.response;
    });
}

function post(apiEndpoint, payload) {
  return axios
    .post(config.backendUrl + apiEndpoint, payload, getOptions())
    .then((response) => {
      return response;
    })
    .catch((err) => {
      return err.response;
    });
}

function put(apiEndpoint, payload) {
  return axios
    .put(config.backendUrl + apiEndpoint, payload, getOptions())
    .then((response) => {
      return response;
    })
    .catch((err) => {
      return err.response;
    });
}

function putToken(apiEndpoint, payload) {
  return axiosInstance
    .put(config.backendUrl + apiEndpoint, payload, getOptionsToken())
    .then((response) => {
      return response;
    })
    .catch((err) => {
      return err.response;
    });
}

async function patchToken(apiEndpoint, payload) {
  return axiosInstance
    .patch(config.backendUrl + apiEndpoint, payload)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      return err.response;
    });
}

async function deleteToken(apiEndpoint) {
  return axiosInstance
    .delete(config.backendUrl + apiEndpoint)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      return err.response;
    });
}
function getOptions() {
  let options = {};
  options.headers = { "Content-Type": "application/json" };

  return options;
}

function getOptionsToken() {
  let options = {};

  if (storage.getItem(variables.TOKEN)) {
    options.headers = {
      Authorization: "bearer " + storage.getItem(variables.TOKEN),
      "Content-Type": "application/json",
    };
  }
  return options;
}
